/* eslint-disable */

/** select columns of table "argo.calendar_current_and_next" */
export enum ArgoCalendarCurrentAndNextSelectColumn {
  /** column name */
  CalendarEventId = 'calendar_event_id',
  /** column name */
  CalendarId = 'calendar_id',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  Day = 'day',
  /** column name */
  EventId = 'event_id',
  /** column name */
  EventTypeId = 'event_type_id',
  /** column name */
  FilterType = 'filter_type',
  /** column name */
  Meta = 'meta',
  /** column name */
  ProductiveTimeElapsed = 'productive_time_elapsed',
  /** column name */
  ProductiveTimeRemaining = 'productive_time_remaining',
  /** column name */
  Range = 'range',
  /** column name */
  TimeEnd = 'time_end',
  /** column name */
  TimeStart = 'time_start'
}

